var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeveltoolCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.565 3H8V328.174M504.565 3V328.174H8M504.565 3L521 19.4348V344.608H24.4348L8 328.174",
    stroke: "#FF419C",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 328.5L25 344.608H521L504.9 328.5H9Z",
    fill: "#AF0054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M521 344.608V19.4348L504.565 3L504.9 328.5L521 344.608Z",
    fill: "#FF419C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.391 198.524V172.698H257.913L232.087 198.524H146.391Z",
    fill: "#FF419C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M369.435 172.698V198.524H300.761L313.674 185.611L326.587 172.698H369.435Z",
    fill: "#FF419C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.975 216.455C225.67 226.629 223.636 244.16 249.931 232.89L314.496 165.977C314.496 165.977 346.192 175.368 347.366 141.325C341.496 141.325 332.105 149.542 332.105 149.542C325.062 148.368 320.366 150.716 320.366 130.76L334.453 120.194C334.453 120.194 294.54 108.455 299.236 150.716L229.975 216.455ZM241 216.455C235.13 217.629 231.609 225.847 241 229.368C250.391 229.368 250.391 217.629 241 216.455Z",
    fill: "#FF419C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 368V345H521.426V0H544.5V368H0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeveltoolCap);
export default __webpack_public_path__ + "static/media/leveltool-cap.0a98791d968fe0b1b14c7f59edfa65f4.svg";
export { ForwardRef as ReactComponent };